import React, { Component } from 'react'
import BigBox from '../../components/ad_types/BigBox'

class Sidebar extends Component {
    render() {
        return (
            <div>
                <BigBox bg={false} view={'all'} visible={true} refresh={false} />
            </div>
        )
    }
}

export default Sidebar
